import { render, staticRenderFns } from "./UploadView.vue?vue&type=template&id=b8a7f44e&scoped=true"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"
import style0 from "./UploadView.vue?vue&type=style&index=0&id=b8a7f44e&prod&scoped=true&lang=css"
import style1 from "./UploadView.vue?vue&type=style&index=1&id=b8a7f44e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a7f44e",
  null
  
)

export default component.exports